/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для карусели баннеров торговых марок на странице категорий.
   */
  app.CategoryBannerCarouselView = app.View.extend({
    el: '.js-owl-tm-carousel',
    additionalOptions: ['onInitialize', 'eventBus'],

    /** @inheritDoc */
    run: function () {
      if (this.$el.length && this.$el.children().length) {
        this.initCarousel();
      }
    },

    /**
     * Отправляет в eventBus событие смены активного баннера и информацию о том какие слайды стали активны
     * Необходимо для отправки данных о баннерах в око
     */
    onBannerChange: function() {
      $('.owl-item.active').each(function(i, el) {
        this.eventBus.trigger('carousel.changed.item', el);
      }.bind(this));
    },

    /**
     * Инициализация карусели.
     */
    initCarousel: function () {
      var $el = this.$el;
      var owlConfig = {
        dots: false,
        slideBy: 1,
        responsive: {
          900: {
            items: 2,
            nav: true
          },
          1100: {
            items: 3,
            nav: true
          },
        },
        mouseDrag: false,
        margin: 0,
        onInitialized: this.onInitialize,
        onChange: function() {
          setTimeout(this.onBannerChange.bind(this), 1000);
        }.bind(this),
      };
      return $el.owlCarousel(owlConfig);
    },
  });
})(jQuery);

}.call(window));